var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_vm._m(0),_c('div',{staticClass:"container"},_vm._l((_vm.messagees),function(message){return _c('NewsCell',{key:message.PublishMessageID,attrs:{"message":message}},[_vm._v(" "+_vm._s(message))])}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container height386"},[_c('img',{attrs:{"src":require("@/assets/zxdt/zxdt.png")}})])
}]

export { render, staticRenderFns }